<template>
  <header :class="['header', headerProps.theme, {'noBorder': headerProps.hideBorder}, {'no-show': headerProps.hideHeader}, {'fixed': headerProps.fixed}]">
    <button
      v-show="!headerProps.btn"
      id="cptheheader-btn-back"
      class="header__btn"
      title="Voltar para o passo anterior"
      @click="previousRoute()"
    >
      <figure>
        <ArrowHeaderGreySvg class="icon" />
      </figure>
    </button>

    <h1
      v-show="headerProps.title"
      class="header__title text__weight--regular"
    >
      {{headerProps.title || ''}}
    </h1>
  </header>
</template>

<script>
export default {
  name: 'AppHeader',
  computed: {
    headerProps() {
      return {
        theme: this.$route.meta?.header?.theme ? this.$route.meta?.header?.theme : 'white',
        hideHeader: !!this.$route.meta?.header?.hideHeader,
        hideBorder: !!this.$route.meta?.header?.hideBorder,
        btn: !!this.$route.meta?.header?.hidePreviousBtn,
        title: this.$route.meta?.header?.title || this.$route.params?.header?.title,
        routeName: this.$route.meta?.header?.routeName,
        fixed: this.$route.meta?.header?.fixed || false,
      };
    },
  },

  methods: {
    previousRoute() {
      this.headerProps.routeName
        ? this.$router.push({ name: this.headerProps.routeName })
        : this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
.no-show {
  display: none!important;
}
.header {
  background-color: #fff;
  width: 100vw;
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  min-height: 52px;
  max-height: 84px;
  border-bottom: 3px solid var(--color-grey-1);
  align-self: center;

  &.fixed {
    position: fixed;
    z-index:2;
  }

  &.black {
    background-color: transparent;
  }

  &.white {
    background-color: #fff;
  }

  &.noBorder {
    border: none;
  }

  @media (min-width: 415px) {
    border-bottom: initial;
  }

  &__btn{
    padding-left: 3.75vw;
    width: fit-content;
    border: none;
    background-color: transparent;
    cursor: pointer;
  }

  &__title {
    font-size: var(--font-size-3);
    grid-column-start: 2;
    display: flex;
    align-items: center;
    font-weight: bold;
  }

  &__title,
  &__btn {
    max-height: 84px;

    .icon {
      width: 17px;

      path {
        fill: black;
      }
    }
  }
}
</style>
